module.exports = __webpack_public_path__ + "static/media/logo-linkedin-white.e2de4e65.svg";